{
  "title": "Faktaruta",
  "factboxDocument": "Faktarutedokument",
  "lockedToArticle": "Låst till artikel",
  "fromPublished": "Låst till publicerad",
  "article": "artikel",
  "original": "original",
  "action": {
    "createFactbox": "Skapa faktaruta",
    "open": "Öppna"
  },
  "usedInArticles": "Används i artiklar",
  "previousPage": "Föregående",
  "nextPage": "Nästa",
  "outOfSync": "Har ändrats",
  "outOfSyncTooltip": "Innehållet i faktarutan i den här artikeln skiljer sig från originalet",
  "inSync": "Matchar",
  "inSyncTooltip": "Innehållet i faktarutan i den här artikeln matchar originalet",
  "prompts": {
    "approveBeforeClose": "Vill du godkänna ändringarna innan du stänger?",
    "savedButNotApproved": "Dina ändringar är sparade men dokumentet är inte satt som godkänt."
  }
}